// extracted by mini-css-extract-plugin
module.exports = {"bg_l5":"#8f8f8f","monoStack":"\"Roboto Mono\",monospace","grid":"Grid_grid__2VCg8","colPair":"Grid_colPair__2jdLo"};